<script>
	let path="/";
	import Navigation from './Navigation/Navigation.svelte'
	import Login from './Login/Login.svelte'
	import {doLogin} from './Login/LoginFunc.svelte';
	import Header from './Header/Header.svelte'
	import Statistic from './Statistic/Statistic.svelte'
	import IVM from './IVM/IVM.svelte'
	import AxApp from './AxApp/AxApp.svelte'
	import Uploads from './Uploads/Uploads.svelte'
	import ProjectConfig from './ProjectConfig/ProjectConfig.svelte'
	import Employ from './Employ/Employ.svelte'
	import Coaching from './Coaching/Coaching.svelte'
	import Mail from './Mail/Mail.svelte'
    import {onMount,onDestroy} from 'svelte';
    import { Router,  Route } from "svelte-routing";
	export let url = "";

	let user=undefined;

	onMount(async()=>{
		doLogin((r)=>{
			if(r.result){
				user=r.user
			}else{
				user={}
			}
		})
	});

	function isEmpty(obj) {
		return Object.keys(obj).length === 0;
	}


</script>
{#if user==undefined}
	LOADING...
{:else if !isEmpty(user)}
	<Header on:loggedOff={()=>{user={}}} bind:user={user} />
	<div style="position:absolute;top:52px;width:calc(100% - 15px);height:calc(100% - 55px);overflow:auto;">
		<Router url={url}>
			<Route path="/"component={Navigation} >
				<Navigation />
			</Route>
			<Route path="/statistics">
				<Statistic bind:user/>
			</Route>
			<Route path="/employ">
				<Employ bind:user/>
			</Route>
			<Route path="/coaching">
				<Coaching bind:user/>
			</Route>
			<Route path="/mail">
				<Mail />
			</Route>
			<Route path="/project-config">
				<ProjectConfig bind:user/>
			</Route>
			<Route path="/ivm">
				<IVM bind:user/>
			</Route>
			<Route path="/uploads">
				<Uploads />
			</Route>
			<Route path="/axapp">
				<AxApp bind:user/>
			</Route>
		</Router>
	</div>
	
{:else }
	<Login on:loggedOn={(event)=>{user=event.detail.user}}/>
{/if}